module.exports = __webpack_public_path__ + "img/service-222.7737161c.png";